import { Box } from "@mui/material";
import "./ConfigurationDrawer.scss";
import { IconButton, Typography } from "@chr/eds-react";
import { ConfigurationDrawerHeaderProps } from "./ConfigurationDrawerProps";
import { useTranslation } from "@chr/online-shared-ui-localizations";

export const ConfigurationDrawerHeader = ({
  handleToggle
}: ConfigurationDrawerHeaderProps) => {
  const translate = useTranslation();
  
  return (
    <Box className="configuration-header">
      <Typography variant="subtitle200">
      {translate('Configure widget')}
      </Typography>
      <IconButton
      icon="close"
      aria-label={translate('Close')}
      onClick={handleToggle}
      />
    </Box>
  );
}

export default ConfigurationDrawerHeader;